import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'
import _imports_1 from '@/app/ui/assets/svg/calendar.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-0a3f7f01")

_pushScopeId("data-v-0a3f7f01")
const _hoisted_1 = { class: "flex items-center justify-between px-4 py-3 border-b border-gray-lp-400" }
const _hoisted_2 = { class: "font-bold text-16px text-black-lp-300" }
const _hoisted_3 = {
  class: "flex flex-col gap-y-3 pt-1 px-4 pb-4 font-montserrat overflow-y-auto",
  style: {"max-height":"calc(55vh / var(--viewport-scale)) !important"}
}
const _hoisted_4 = { class: "w-422px max-w-full mx-auto flex gap-x-3" }
const _hoisted_5 = { class: "w-244px max-w-full flex flex-col gap-y-2" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { class: "font-semibold text-black-lp-300 text-sm" }, "Tanggal", -1)
const _hoisted_7 = {
  class: "flex items-center rounded-md border border-gray-lp-400 relative text-black-lp-100 text-sm",
  style: {"height":"2.435rem"}
}
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "calendar",
  class: "w-4 absolute left-2"
}, null, -1)
const _hoisted_9 = { class: "flex-1 flex flex-col gap-y-2 relative" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { class: "font-semibold text-black-lp-300 text-sm" }, "Waktu", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "absolute right-3 top-9 text-14px text-black-lp-300" }, "WIB", -1)
const _hoisted_12 = { class: "w-422px max-w-full mx-auto rounded-xl border border-gray-lp-1000 shadow-datepicker overflow-hidden" }
const _hoisted_13 = { class: "w-422px max-w-full mx-auto flex items-center gap-x-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DatePickerV2 = _resolveComponent("DatePickerV2")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.visible = $event)),
    persistent: "",
    customBody: "p-0",
    customWidth: "dialog-date-time",
    showOverflow: false
  }, {
    header: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
        _createVNode("img", {
          src: _imports_0,
          class: "w-6 h-6 cursor-pointer",
          alt: "close",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
        })
      ])
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode("input", {
                "data-testid": "date-time-input-date",
                type: "text",
                value: _ctx.draftDateText,
                placeholder: "Masukan tanggal",
                class: "h-full flex items-center border-l border-gray-lp-400 ml-8 px-2 w-full rounded-r-md outline-none",
                onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onInputDateText && _ctx.onInputDateText(...args))),
                onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onBlurDate && _ctx.onBlurDate(...args)))
              }, null, 40, ["value"])
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_DatePickerV2, {
              modelValueTime: _ctx.draftTimeDate,
              placeholder: "00:00",
              onSelectedTime: _ctx.onTimeSelected,
              onBlur: _ctx.onValidateTime,
              showDatePicker: false,
              showTimePicker: "",
              customClass: "mb-0",
              customClassTime: "w-full",
              maxDate: new Date(new Date().setDate(new Date().getDate() + 1))
            }, null, 8, ["modelValueTime", "onSelectedTime", "onBlur", "maxDate"]),
            _hoisted_11
          ])
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode(_component_DatePicker, {
            inline: "",
            class: "date-time-calendar",
            value: _ctx.draftCalendarDate,
            "disabled-date": _ctx.isDateDisabled,
            onInput: _ctx.selectCalendarDate
          }, null, 8, ["value", "disabled-date", "onInput"])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_LpButton, {
            "data-testid": "date-time-input-cancel",
            title: "Batal",
            color: "white",
            textColor: "red-lp-100",
            customClass: "border border-red-lp-100",
            "is-width-full": "",
            outline: "",
            onClick: _ctx.onClose
          }, null, 8, ["onClick"]),
          _createVNode(_component_LpButton, {
            title: "Simpan",
            color: "red-lp-2400",
            textColor: "white",
            "is-width-full": "",
            onClick: _ctx.onSave
          }, null, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
})